import { render, staticRenderFns } from "./SummonsEdit.vue?vue&type=template&id=2ef6f6f8&scoped=true&"
import script from "./SummonsEdit.vue?vue&type=script&lang=js&"
export * from "./SummonsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SummonsEdit.vue?vue&type=style&index=0&id=2ef6f6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6f6f8",
  null
  
)

export default component.exports